import { useState, useEffect } from 'react';
import { hrAPI } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Loader2, Clock } from 'lucide-react';
import { formatMinutes, formatDateShort } from './hrUtils';

export const TimesheetTab = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    hrAPI.myTimesheet().then((res) => setData(res.data)).catch(() => setData({ entries: [], total_minutes: 0 }));
  }, []);

  if (!data) return <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-cyan-500" /></div>;

  const fmtTime = (iso) => iso ? new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '—';

  return (
    <div className="space-y-6" data-testid="hr-timesheet-tab">
      <Card className="bg-white border-slate-200">
        <CardContent className="p-5 flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500">Total Tracked Time (last {data.entries.length} shifts)</p>
            <p className="text-3xl font-bold text-slate-800" data-testid="hr-timesheet-total">{formatMinutes(data.total_minutes)}</p>
          </div>
          <div className="w-12 h-12 rounded-xl bg-cyan-100 flex items-center justify-center">
            <Clock className="w-6 h-6 text-cyan-600" />
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white border-slate-200">
        <CardHeader><CardTitle className="text-slate-800 text-lg">My Shifts & Attendance <span className="text-xs font-normal text-slate-400 ml-2">times in MST</span></CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-2" data-testid="hr-timesheet-entries">
            {data.entries.length === 0 && <p className="text-sm text-slate-400 py-4">No time entries yet. Use the Clock In / Out widget in the sidebar to start tracking.</p>}
            {data.entries.map((e) => (
              <div key={e.id} className="flex items-center justify-between p-3 rounded-xl border border-slate-200">
                <div>
                  <p className="text-sm font-medium text-slate-800">{formatDateShort(e.clock_in)}</p>
                  <p className="text-xs text-slate-500">{fmtTime(e.clock_in)} → {e.clock_out ? fmtTime(e.clock_out) : 'in progress'}</p>
                </div>
                <div className="text-right">
                  {e.clock_out
                    ? <Badge variant="secondary">{formatMinutes(e.duration_minutes)}</Badge>
                    : <Badge className="bg-emerald-100 text-emerald-700">Active</Badge>}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
